<template>
  <router-view></router-view>
  <WhatsAppChat />
</template>

<script>
import WhatsAppChat from '@/components/WhatsAppChat.vue'

export default {
  name: 'App',
  components: { WhatsAppChat }
}
</script>

<style>

#app {
  //font-family: Avenir, Helvetica, Arial, sans-serif;
  //-webkit-font-smoothing: antialiased;
  //-moz-osx-font-smoothing: grayscale;
}
</style>
